import { Button, TextField, Typography } from "@mui/material";
import { useState } from "react";

export default function AddPostalCode(props) {
  const { onSave, onCancel } = props;
  const [postalCode, setPostalCode] = useState(undefined);
  return (
    <div>
      <Typography>Add Postal Code</Typography>
      <TextField
        size="small"
        label="Postal Code"
        fullWidth
        value={postalCode}
        onChange={(e) => setPostalCode(e?.target?.value)}
      />
      <div style={{ display: "flex", flexDirection: "row", marginTop: 10 }}>
        <Button
          variant="contained"
          size="small"
          style={{ marginRight: 10 }}
          onClick={() => {
            onSave(postalCode);
            onCancel();
          }}
        >
          Save
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            onCancel();
          }}
        >
          Close
        </Button>
      </div>
    </div>
  );
}
